import {Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Paper from "@mui/material/Paper";
import React, {useEffect, useState} from "react";
import {useApplicationContext} from "../../ApplicationContext";
import {GetFilterTagData} from "../../apiClient/Api";
import SettingsPageHeader from "./Settings/SettingsPageHeader";


export const FilterTags = () => {

    const context = useApplicationContext();
    const [initialized, setInitialized] = useState(false);
    const [filterTags, setFilterTags] = useState<GetFilterTagData[]>([])

    useEffect(() => {
        if (!initialized) {
            setInitialized(true)
            context.api.filterTags.filterTagsListFilterTags().then(tags => {
                if (tags.data != undefined) {
                    setFilterTags(tags.data);
                }
            }).catch(context.apiError)
        }
    }, [])

    return <>
        <SettingsPageHeader
            sectionKey="filterTags"
            chip={<Chip size="small" variant="outlined" label="Wird automatisch gepflegt"/>}
        />
        <TableContainer component={Paper} variant="outlined" sx={{borderRadius: 2.5}}>
            <Table sx={{minWidth: 650}} aria-label="dateifilter-tabelle">
                <TableHead >
                    <TableRow>
                        <TableCell style={{fontWeight: "bold"}}>
                            ID
                        </TableCell>
                        <TableCell style={{fontWeight: "bold"}}>
                            Text
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filterTags.map(tag => <TableRow key={tag.identifier}>
                        <TableCell>{tag.identifier}</TableCell>
                        <TableCell>{tag.name}</TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>
    </>
}
